import fa from "./Fasilitas (1).fa344530e55ebad87abf.webp";
import fa2 from "./Fasilitas (2).b7f6c646a48ad09d1e46.webp";
import fa3 from "./Fasilitas (3).f8ce630b90ecb21b60c3.webp";
import fa4 from "./Fasilitas (4).7afc68c8183d973e26cd.webp";
import fa5 from "./Fasilitas (5).4a6b82377fda5572bc98.webp";
import fa6 from "./SMS1.webp";
const aboutImages = [
  {
    src: fa2,
    text: "View Danau",
  },
  {
    src: fa3,
    text: "Pedestrian Walk",
  },
  {
    src: fa4,
    text: "Boulevard",
  },
  {
    src: fa5,
    text: "Clubhouse",
  },
  {
    src: fa6,
    text: "Mall Summarecon",
  },
];

export default aboutImages;
